<div class="d-flex gap-2 mb-2">
    <span class="material-symbols-outlined">
        percent
    </span>
    <div class="w-100">
        <h3 class="text-black flex-grow-1 mb-2 d-flex gap-2">
            New Offer Added
        </h3>
        <p class="pb-0 mb-2 text-darkgray text-darkgray">A new offer has been added!</p>
        <div class="info py-2">
            <p class="mb-1">
                <label class="label">Load#</label>:
                <span (click)="onLoadDetailClick()" style="cursor: pointer;">
                    {{loadCarrierBidNotificationAlertModel?.loadDetailId}}
                </span>
            </p>
            <p class="mb-1">
                <label class="label">Lane</label>: <span>{{ getLane() }}</span>
            </p>
            <p class="mb-1">
                <label class="label">Pick up Date</label>: <span>{{ dateTimeCellRenderer() }}</span>
            </p>
            <p class="mb-1">
                <label class="label">Customer Name</label>: <span>{{ loadCarrierBidNotificationAlertModel?.customerName
                    }}</span>
            </p>
            <p class="mb-1">
                <label class="label">Initial Offer</label>: <span>{{
                    loadCarrierBidNotificationAlertModel?.initialBidAmount
                    }}</span>
            </p>
            <p class="mb-1"
                *ngIf="loadCarrierBidNotificationAlertModel.bidStage === bidStages.ApproverCountered || loadCarrierBidNotificationAlertModel.bidStage === bidStages.RequestorCountered">
                <label class="label">Counter Offer</label>: <span>{{
                    loadCarrierBidNotificationAlertModel?.approvedAmount
                    }}</span>
            </p>
            <p class="mb-1"
                *ngIf="loadCarrierBidNotificationAlertModel.bidStage === bidStages.RequestorCountered && loadCarrierBidNotificationAlertModel.action === bidActionType.Countered">
                <label class="label">Carrier Counter</label>: <span>{{ loadCarrierBidNotificationAlertModel?.bidAmount
                    }}</span>
            </p>
        </div>
    </div>
</div>


<div class="d-flex gap-2 pl-4 ml-1">
    <button class="btn btn-primary" (click)="approveBidPannel.toggle($event)"
        *ngIf="loadCarrierBidNotificationAlertModel.loadCarrierBidStatusName === loadBidStatus.Live && loadCarrierBidNotificationAlertModel.bidStage !== bidStages.ApproverCountered">
        Accept
        <p-overlayPanel #approveBidPannel styleClass="overlay-panel-sync p-2">
            <ng-template pTemplate="content">
                <app-approve-reject-bid [carrierBid]="bid" [approveBid]="true" [isApprove]="true"
                    [isOverlayPanel]="true" (closeOverlayPanel)="onOverlayPanelClose($event)">
                </app-approve-reject-bid>
            </ng-template>
        </p-overlayPanel>
    </button>
    <button class="btn btn-primary" (click)="onCoverClick()"
        *ngIf="loadCarrierBidNotificationAlertModel.loadCarrierBidStatusName === loadBidStatus.Live && loadCarrierBidNotificationAlertModel.bidStage === bidStages.ApproverCountered">
        Cover
    </button>
    <button class="btn btn-primary" (click)="counterBidPannel.toggle($event)"
        *ngIf="loadCarrierBidNotificationAlertModel.loadCarrierBidStatusName === loadBidStatus.Live && loadCarrierBidNotificationAlertModel.bidStage !== bidStages.RequestorCountered">
        Counter
        <p-overlayPanel #counterBidPannel styleClass="overlay-panel-sync p-2">
            <ng-template pTemplate="content">
                <app-approve-reject-bid [carrierBid]="bid" [approveBid]="true" [isApprove]="false"
                    [isOverlayPanel]="true" (closeOverlayPanel)="onOverlayPanelClose($event)">
                </app-approve-reject-bid>
            </ng-template>
        </p-overlayPanel>
    </button>
    <button class="btn btn-outline-secondary" (click)="rejectBidPannel.toggle($event)"
        *ngIf="loadCarrierBidNotificationAlertModel.loadCarrierBidStatusName === loadBidStatus.Live">
        Reject
        <p-overlayPanel #rejectBidPannel styleClass="overlay-panel-sync p-2">
            <ng-template pTemplate="content">
                <app-approve-reject-bid [carrierBid]="bid" [approveBid]="false" [isOverlayPanel]="true" [isRejectClicked]="true"
                    (closeOverlayPanel)="onOverlayPanelClose($event)">
                </app-approve-reject-bid>
            </ng-template>
        </p-overlayPanel>
    </button>
</div>